import cities from './cities';

// Vehicles
export const authorize = ['Car', 'Van', 'Motorcycle', 'Campervan', 'Lorry'];

export const defaultOption = { value: 'choose', text: 'uiText.choose' };

const vehicle = [
  { value: 'Car', text: 'option.vehicleType.001' },
  { value: 'Van', text: 'option.vehicleType.002' },
  { value: 'Motorcycle', text: 'option.vehicleType.003' },
  { value: 'Moped or light quadricycle', text: 'option.vehicleType.004' },
  { value: 'Snowmobile', text: 'option.vehicleType.005' },
  { value: 'Trailer', text: 'option.vehicleType.006' },
  { value: 'Caravan', text: 'option.vehicleType.007' },
  { value: 'Campervan', text: 'option.vehicleType.008' },
  { value: 'Lorry', text: 'option.vehicleType.009' },
  { value: 'Tractor', text: 'option.vehicleType.010' },
  { value: 'All-terrain vehicle', text: 'option.vehicleType.011' },
  { value: 'Museum vehicle', text: 'option.vehicleType.012' },
  { value: 'Other vehicle', text: 'option.vehicleType.013' },
];

const home = [
  { value: 'House', text: 'option.homeType.001' },
  { value: 'Apartment building', text: 'option.homeType.002' },
  { value: 'Terraced house', text: 'option.homeType.003' },
  { value: 'Detached house', text: 'option.homeType.004' },
  { value: 'Duplex', text: 'option.homeType.005' },
  { value: 'Agricultural building', text: 'option.homeType.006' },
  { value: 'Sauna', text: 'option.homeType.007' },
  { value: 'Free-time residence', text: 'option.homeType.008' },
];

const person = [
  { value: 'Me', text: 'option.person.001' },
  { value: 'Another adult', text: 'option.person.002' },
  { value: 'Child', text: 'option.person.003' },
  { value: 'Unborn child or twins', text: 'option.person.004' },
];

const travel = [
  { value: 'Me', text: 'option.insuredItem.001' },
  { value: 'Family member', text: 'option.insuredItem.002' },
  { value: 'Luggage only', text: 'option.insuredItem.003' },
];

const animal = [
  { value: 'Pedigree dog', text: 'option.insured-animal.001' },
  { value: 'Mixed-breed dog', text: 'option.insured-animal.002' },
  { value: 'Pedigree cat', text: 'option.insured-animal.003' },
  { value: 'Native breed cat', text: 'option.insured-animal.004' },
  { value: 'Horse', text: 'option.insured-animal.005' },
];

const boat = [
  { value: 'Motorboat', text: 'option.boatType.001' },
  { value: 'Motor sailor', text: 'option.boatType.002' },
  { value: 'Sailboat', text: 'option.boatType.003' },
];

const forest = [...cities];

const valuable = [
  { value: 'Musical', text: 'option.valuableType.001' },
  { value: 'Camera and accessories', text: 'option.valuableType.002' },
  { value: 'Lens', text: 'option.valuableType.003' },
  { value: 'Weapon', text: 'option.valuableType.004' },
  { value: 'Watch', text: 'option.valuableType.005' },
  { value: 'Jewellery', text: 'option.valuableType.006' },
];

export const menuCategory = {
  home: { title: 'labelText.homeType', optionList: home },
  boat: { title: 'labelText.boatType', optionList: boat },
  person: { title: 'labelText.person', optionList: person },
  travel: { title: 'labelText.insuredItem', optionList: travel },
  animal: { title: 'labelText.insured-animal', optionList: animal },
  forest: { title: 'labelText.forestMunicipality', optionList: forest },
  vehicle: { title: 'labelText.vehicleType', optionList: vehicle },
  valuable: { title: 'labelText.valuableType', optionList: valuable },
};
